import { getSongAtIndex, startSpot, doUpdateFlagStatus } from './player-shared-action-creators';
import { showNotification } from '../../actions/notification';
import { playFullMedia} from '../../actions/playmedia';
import RibbonsUtil from '../../utils/RibbonsUtil';

import Asset from "../../requests/apa/Asset";

import * as EVENTS from '../../actions/musica/playermusica';
import * as playerConstants from '../../constants/musica/player';
import * as userType from '../../constants/musica/users-type';
import MusicActionsUtil from '../../utils/music/MusicActionsUtil';
import Utils from '../../utils/Utils';
import logger from 'src/utils/logger/logger';

export const changeBtnFavsFromPlayer = (status, dispatch) => () => {
  try {
    const btnFav = document.getElementById("favoriteBtn");
    if (btnFav !== 'undefined') {
      switch (status) {
        case 'favorite':
          btnFav.getElementsByTagName('img')[0].setAttribute("src", Asset.get('player_controls_favorited_selected'));
          break;
        case 'unfavorite':
          btnFav.getElementsByTagName('img')[0].setAttribute("src", Asset.get('player_controls_favorited'));
          break;
        default:
          logger.debug("Undefined");
          break;
      }
    }
  } catch(e){ /***/ }
};

export const changeBtnRepeatFromPlayer = () => (dispatch, getState) => {
  const stateShuffle = getState().playermusica.repeatMode;
  const btnRepeat= document.getElementById("repeatBtn");
  if (btnRepeat !== 'undefined') {
    switch (stateShuffle) {
      case playerConstants.PLAYER_REPEAT_MODES.SIMPLE:
        btnRepeat.getElementsByTagName('img')[0].setAttribute("src", Asset.get('player_controls_repeat'));
        break;
      case playerConstants.PLAYER_REPEAT_MODES.REPEAT_SINGLE:
        btnRepeat.getElementsByTagName('img')[0].setAttribute("src", Asset.get('player_controls_repeat_one_selected'));
        break;
      case playerConstants.PLAYER_REPEAT_MODES.REPEAT_ALL:
        btnRepeat.getElementsByTagName('img')[0].setAttribute("src", Asset.get('player_controls_repeat_selected'));
        break;
      default:
        logger.debug("Undefined");
        break;
    }

  }
};

export const doFavorite = (cb) => (dispatch, getState) => {
  const state = getState();
  const currentType = state.playermusica.contentType;
  const currentContent =  state.playermusica.currentContent;
  let content = {
    type: currentType,
    id: (currentType === 'song') ? currentContent.id : currentContent.id,
    isFavorite: currentContent.isFavorite,
    fromPlayer: true
  };

  if(currentType === 'radio'){
    content = {
      ...content,
      isFavorite: undefined,
      isFollowing: currentContent.isFavorite,
    }
  }

  MusicActionsUtil.toggleFollow(content).then((toggleValue) => {
    if(currentType === 'song' || currentType === 'radio'){
      if (cb && Utils.isFunction(cb)){
        cb(currentContent.isFavorite);
      }
    }

    if(currentContent.isFavorite){
      dispatch({ type: EVENTS.UPDATE_FAV_STATUS_CONTENT, isFavorite: false });
      const action = {id: currentContent.id, isFavorite: false };
      if(currentType !== 'radio'){
        dispatch({ type: EVENTS.UPDATE_FAV_STATUS_PLAYLIST,  action});
      }
    } else {
      dispatch({ type: EVENTS.UPDATE_FAV_STATUS_CONTENT, isFavorite: true });
      const action = { id: currentContent.id , isFavorite: true};
      if(currentType !== 'radio'){
        dispatch({ type: EVENTS.UPDATE_FAV_STATUS_PLAYLIST, action });
      }
    }
    dispatch(doUpdateFlagStatus(true));
  }).catch(err => {
    logger.debug('Cant update following list');
  });
};

export const doToggleRepeat = () => (dispatch) => {
  dispatch({ type: EVENTS.TOGGLE_REPEAT });
  dispatch(changeBtnRepeatFromPlayer());
};

export const doToggleShuffle = () => (dispatch, getState) => {
  const {user : {musicUser :{type = userType.ANONYMOUS} = {}} = {},
  playermusica:{currentContent :{songSourceType = playerConstants.ACCESS_TYPES.UNKNOWN} ={}} = {}} = getState();
  const isUserPremium = type === userType.PREMIUM;
  if (songSourceType === playerConstants.ACCESS_TYPES.FREE_PLAYLIST && !isUserPremium) {
    return false;
  }

  dispatch({ type: EVENTS.TOGGLE_SHUFFLE });
  return true;
};

export const goToPreviewSong = () => (dispatch, getState) => {
  const state = getState();
  const {user : {musicUser :{type = userType.ANONYMOUS} = {}} = {},
  playermusica:statePlayer = {}} = getState();
  const currentIndex = parseInt(statePlayer.currentContent.index);
  const isFreePlaylist = statePlayer.currentContent.songSourceType === playerConstants.ACCESS_TYPES.FREE_PLAYLIST;
  const isShuffle = statePlayer.isShuffle;
  let song;
  let favoriteState;

  if (isFreePlaylist && type !== userType.PREMIUM) {
    return Promise.resolve();
  }

  if(isShuffle){
    const orderShuffleArray =  statePlayer.playlist.shuffleElements;
    const shuffleIndex = orderShuffleArray[currentIndex - 1].order;
    song = getSongAtIndex(statePlayer, shuffleIndex);
  } else {
    song = getSongAtIndex(statePlayer, currentIndex - 1);
  }

  if (currentIndex > 0) {
    const musicRb = new RibbonsUtil();
    musicRb.getIsFavoriteFromApi("song", state.user, { countryCode: state.user.countryCode, contentId: song.id }).then((resp) =>{
      song.isFavorite = resp.isFavorite;
      if (song.isFavorite) {
        favoriteState = 'favorite';
      } else {
        favoriteState = 'unfavorite';
      }

      let newCurrentContent = {
        ...song,
        index: currentIndex - 1
      };

      dispatch({
        type: EVENTS.DELETE_OLD_CURRENT_CONTENT
      });

      dispatch({
        type: EVENTS.UPDATE_CURRENT_CONTENT,
        newCurrentContent
      });

      // deprecated ahora se hace el cambio en state.isSongFavorite en PlayerControls
      // dispatch(changeBtnFavsFromPlayer(favoriteState));

      const contentId = song.id ? song.id : null;

      dispatch(playFullMedia({
        playerstate: 'PLAYING',
        source: {
          audiosource: song.url,
        },
        ispreview: false,
        islive: false,
        ispip: false,
      }));
    });
  }
};

export const goToNextSong = (time = null) => (dispatch, getState) => {
  const state = getState();
  const statePlayer = state.playermusica;
  const currentIndex = parseInt(statePlayer.currentContent.index);
  const playlistLength = statePlayer.playlist.originalContent.length;
  const repeatMode = statePlayer.repeatMode;
  const isLastElement = playlistLength - 1 === currentIndex;
  const isFreePlaylist = statePlayer.currentContent.songSourceType === playerConstants.ACCESS_TYPES.FREE_PLAYLIST;
  const isShuffle = statePlayer.isShuffle;
  let nextIndex = currentIndex + 1;
  let song;
  let favoriteState;
  if(isLastElement && !isShuffle && repeatMode == playerConstants.PLAYER_REPEAT_MODES.SIMPLE){
    dispatch(showNotification({show:true, title: null, msg: 'Esta es la última canción de la cola de reproducción', faClass: null, type:'message'}));
    logger.debug('Last element of the playlist!');
    return null;
  }

   /**
   * Se deshabilita el envío de métricas de audio sendMetricsMusica.
   * Las métricas audiotrack success de la migración de música se
   * mandan en video/index, en método onEnded
   *
   * <code>
   * TrackerManager.resetTimePlaying();
   * TrackerManager.end(secondsPlayingAudio);
   * </code>
   */
  //dispatch(sendMetricsMusica(time, false));

  if (isFreePlaylist && statePlayer.spot.isEnable) {
    dispatch(startSpot());
    return;
  }

  if (statePlayer.playlist.originalContent.length <= 1) {
    logger.debug('Playlist has no elements or just one element, will play same element');
    return null;
  }

  if (isLastElement && (repeatMode == playerConstants.PLAYER_REPEAT_MODES.REPEAT_ALL || isShuffle)) {
    nextIndex = 0;
    logger.debug(`Repeat all activates. Reached playlist end. Will play first song with index!!! ${nextIndex}`);
  }

  if(isShuffle) {
    const orderShuffleArray =  statePlayer.playlist.shuffleElements;
    const shuffleIndex = orderShuffleArray[nextIndex].order;
    song = getSongAtIndex(statePlayer, shuffleIndex);
  } else {
    song = getSongAtIndex(statePlayer, nextIndex);
  }

  const musicRb = new RibbonsUtil();
  musicRb.getIsFavoriteFromApi("song", state.user, { countryCode: state.user.countryCode, contentId: song.id }).then((resp) =>{
    song.isFavorite = resp.isFavorite;
    if (song.isFavorite) {
      favoriteState = 'favorite';
    } else {
      favoriteState = 'unfavorite';
    }

    let newCurrentContent = {
      ...song,
      index: nextIndex
    };

    dispatch({
      type: EVENTS.DELETE_OLD_CURRENT_CONTENT
    });

    dispatch({
      type: EVENTS.UPDATE_CURRENT_CONTENT,
      newCurrentContent
    });

    // deprecated ahora se hace el cambio en state.isSongFavorite en PlayerControls
    //dispatch(changeBtnFavsFromPlayer(favoriteState));

    dispatch(playFullMedia({
      playerstate: 'PLAYING',
      source: {
        audiosource: song.url,
      },
      ispreview: false,
      islive: false,
      ispip: false,
      isNextSong: true,
    }));
  });
};

export const typeDetails = (sourceType) => {
  let type = null;

  if(sourceType === 1 || sourceType === 2 || sourceType === 3 || sourceType === 13 || sourceType === 14){
    type = 'playlist';
  } else if(sourceType === 8 || sourceType === 5 ){
    type = 'song';
  } else if(sourceType === 9) {
    type = 'album';
  } else {
    type = 'song';
  }

  return type;
}





// WEBPACK FOOTER //
// ./src/actions/musica/player-controls-user.js